"use client";

// import Calculator from "../components/Home/Calculator";
import WhyTrustUs from "../components/Home/WhyTrustUs";

import CourseOffered from "../components/Home/CourseOffered";
import CTABanner from "../components/Home/CTABanner";
import FAQSection from "../components/Home/FAQSection";
import HeroSection from "../components/Home/HeroSection";
import DownloadApp from "../components/Home/DownloadApp";
import LoanHighlights from "../components/Home/LoanHighlights";
import Testimonials from "../components/Home/Testimonials";
import WhyChooseUs from "../components/Home/WhyChooseUs";
import React, { useState, useEffect } from "react";
// import { Toaster } from 'react-hot-toast';
import Footer from "../components/Footer";
import HowWeWorkImg from "../images/about_3.png";
import { FiEdit, FiFileText, FiSearch, FiCreditCard } from "react-icons/fi";
import { motion } from "framer-motion";
// import Navbar from '../components/Navbar';
// import AdmissionForm from '../components/AdmissionForm";

const HomePage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const handleApplyNow = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const cardStyle = {
    background: "#FFFFFF",
    borderRadius: 16,
    boxShadow: "0 4px 16px rgba(79, 160, 255, 0.1)",
    padding: "2rem",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    border: "1px solid #E5E5E5",
  };

  const iconStyle = {
    fontSize: 40,
    marginBottom: 16,
    color: "#4FA0FF",
  };

  const titleStyle = {
    fontWeight: 700,
    fontSize: "1.3rem",
    marginBottom: 12,
    color: "#1D3557",
  };

  const descStyle = {
    color: "#1D3557",
  };

  const featureCardStyle = {
    background: "#fff",
    borderRadius: 16,
    boxShadow: "0 4px 16px rgba(79, 160, 255, 0.1)",
    padding: "2rem",
    textAlign: "left",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    minHeight: 180,
    border: "1px solid #E5E5E5",
  };

  const featureIconStyle = {
    fontSize: 36,
    marginBottom: 16,
    color: "#4FA0FF",
  };

  const featureTitleStyle = {
    fontWeight: 700,
    fontSize: "1.2rem",
    marginBottom: 8,
    color: "#1D3557",
  };

  const featureDescStyle = {
    color: "#1D3557",
    fontSize: "1rem",
  };
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setShowScroll(true);
      } else {
        setShowScroll(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="min-h-screen overflow-x-hidden">
      {/* <Toaster position="top-center" /> */}
      {/* Navbar */}
      {/* <Navbar onApplyNow={handleApplyNow} /> */}
      {/* Main Content */}
      <main>
        <HeroSection onApplyNow={handleApplyNow} />
        {/* Why Choose Salarymates Section */}
        <WhyChooseUs />
        {/* <Calculator /> */}
        <WhyTrustUs />

        {/* How It Works Section - FIXED FOR BOTH MOBILE & LAPTOP */}
<section className="relative bg-[#0A1620] overflow-hidden py-12 md:py-20">
  {/* Background */}
  <div className="absolute inset-0 bg-[#0A1620]"></div>
  
  {/* Accent Gradients */}
  <div className="absolute top-20 right-0 w-[300px] md:w-[500px] h-[300px] md:h-[500px] bg-[#1B4D5E]/20 rounded-full blur-[100px] md:blur-[120px]"></div>
  <div className="absolute bottom-40 left-0 w-[250px] md:w-[400px] h-[250px] md:h-[400px] bg-[#1A3B4D]/20 rounded-full blur-[80px] md:blur-[100px]"></div>

  <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    {/* Header */}
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      className="text-center mb-8 md:mb-12"
    >
      <div className="flex items-center justify-center gap-2 mb-2">
        <span className="text-2xl md:text-3xl">⚙️</span>
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white">
          How It <span className="text-[#7BC4E0]">Works</span>
        </h2>
      </div>
      <div className="w-16 md:w-20 h-0.5 bg-gradient-to-r from-[#7BC4E0] to-transparent mx-auto"></div>
    </motion.div>

    {/* 3 CARDS - Vertical on Mobile, Horizontal on Laptop */}
    <div className="flex flex-col md:flex-row gap-4 md:gap-6 max-w-4xl mx-auto">
      {/* Step 1 */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.1 }}
        className="flex-1"
      >
        <div className="bg-gradient-to-br from-[#1A2F3A] to-[#0F2128] rounded-xl border border-[#2D5F7A]/30 p-5 md:p-6 h-full hover:border-[#7BC4E0]/30 transition-all duration-300">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-[#2D5F7A] flex items-center justify-center">
              <span className="text-white font-bold text-base md:text-lg">1</span>
            </div>
            <h3 className="text-white font-semibold text-base md:text-lg">Share Details</h3>
          </div>
          <p className="text-[#CCE6F5] text-sm md:text-base leading-relaxed pl-2">
            Share your basic details and documents
          </p>
        </div>
      </motion.div>

      {/* Step 2 */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.2 }}
        className="flex-1"
      >
        <div className="bg-gradient-to-br from-[#1A2F3A] to-[#0F2128] rounded-xl border border-[#2D5F7A]/30 p-5 md:p-6 h-full hover:border-[#7BC4E0]/30 transition-all duration-300">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-[#2D5F7A] flex items-center justify-center">
              <span className="text-white font-bold text-base md:text-lg">2</span>
            </div>
            <h3 className="text-white font-semibold text-base md:text-lg">Review</h3>
          </div>
          <p className="text-[#CCE6F5] text-sm md:text-base leading-relaxed pl-2">
            We review your profile
          </p>
        </div>
      </motion.div>

      {/* Step 3 */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.3 }}
        className="flex-1"
      >
        <div className="bg-gradient-to-br from-[#1A2F3A] to-[#0F2128] rounded-xl border border-[#2D5F7A]/30 p-5 md:p-6 h-full hover:border-[#7BC4E0]/30 transition-all duration-300">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-[#2D5F7A] flex items-center justify-center">
              <span className="text-white font-bold text-base md:text-lg">3</span>
            </div>
            <h3 className="text-white font-semibold text-base md:text-lg">Support</h3>
          </div>
          <p className="text-[#CCE6F5] text-sm md:text-base leading-relaxed pl-2">
            Get access to suitable financial support
          </p>
        </div>
      </motion.div>
    </div>

    {/* Stats Grid - Optional, remove if not needed */}
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: 0.4 }}
      className="grid grid-cols-2 md:grid-cols-4 gap-3 max-w-3xl mx-auto mt-10"
    >
      {[
        { value: "2 Mins", label: "Application", icon: "⏱️" },
        { value: "100%", label: "Paperless", icon: "📱" },
        { value: "24/7", label: "Support", icon: "🕒" },
        { value: "Instant", label: "Transfer", icon: "⚡" }
      ].map((stat, index) => (
        <div key={index} className="bg-[#1A2F3A]/50 rounded-lg p-3 text-center border border-[#2D5F7A]/20">
          <span className="text-xl md:text-2xl block text-[#7BC4E0]">{stat.icon}</span>
          <div className="text-sm md:text-base font-bold text-white">{stat.value}</div>
          <div className="text-xs text-[#8FAFC7]">{stat.label}</div>
        </div>
      ))}
    </motion.div>
  </div>
</section>
        {/* <CourseOffered /> */}
        <Testimonials />
        {/* <LoanHighlights /> */}
        {/* <DownloadApp /> */}
        <FAQSection />
        {/* <CTABanner onApplyNow={handleApplyNow} /> */}
      </main>
      {/* Footer */}
      {/* <Footer /> */}
      
      {/* Scroll to Top Button */}
      {showScroll && (
       <button
  onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
  className="fixed bottom-4 right-4 md:bottom-6 md:right-6 z-50 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-white/90 backdrop-blur-sm text-[#0A1620] text-xl md:text-2xl rounded-full shadow-lg transition-all duration-300 border border-gray-200 hover:bg-white hover:shadow-xl hover:scale-110 active:scale-95"
>
  ↑
</button>
      )}
    </div>
  );
};

export default HomePage;